import { promiseCallApi, fetchApi, GET_METHOD, POST_METHOD, REQUEST_STATUS, switchSnack, gmoErrorMsg } from '~/stores/tools/commons';

import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  list: null,
  selected: null,
}

// sliceを生成
export const institutionSearchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    searchInst: (state, action) => {
      return {
        ...state,
        list: action.payload
      }
    },
    selectedInst: (state, action) => {
      return {
        ...state,
        selected: action.payload
      }
    },
    resetInst: (state, action) => {
      return {
        ...state,
        list: null,
        selected: null
      }
    },
  },
})
export const { searchInst, selectedInst, resetInst } = institutionSearchSlice.actions

export const searchForm = formData => {
  const params = {medical_agency: formData}
  return (async dispatch => {
    const response = await promiseCallApi(`${process.env.NEXT_PUBLIC_API_BASE_URL}/api/v1/medical_institutions/search.json`, GET_METHOD, params);
    if(response.status === REQUEST_STATUS.OK) {
      // 成功
      dispatch(searchInst(response.data));
    }
    else {
      // 失敗
      batch(() => {
        // dispatch(switchSnack(response.status));
        // dispatch ({ type: NEW_CREATE_ERROR });
      })
    }
  });
}

export default institutionSearchSlice.reducer
